__turbopack_context__.v({
  "button": "primitives-module__6Uo1sW__button",
  "buttonArrow": "primitives-module__6Uo1sW__buttonArrow",
  "buttonIcon": "primitives-module__6Uo1sW__buttonIcon",
  "card": "primitives-module__6Uo1sW__card",
  "container": "primitives-module__6Uo1sW__container",
  "heading": "primitives-module__6Uo1sW__heading",
  "pill": "primitives-module__6Uo1sW__pill",
  "section": "primitives-module__6Uo1sW__section",
  "stat": "primitives-module__6Uo1sW__stat",
  "statGhost": "primitives-module__6Uo1sW__statGhost",
  "statLabel": "primitives-module__6Uo1sW__statLabel",
  "statValue": "primitives-module__6Uo1sW__statValue",
  "text": "primitives-module__6Uo1sW__text",
});
